import endsWith from 'lodash-es/endsWith';
import { Redirect } from 'react-router-dom';
import { RouteChildrenProps } from 'react-router';
import { RouteConfig } from 'react-router-config';

export default (redirects: Record<string, string>): RouteConfig[] =>
  Object.entries(redirects).map(([path, to]): RouteConfig => {
    const hasGlob = endsWith(path, '*');
    const basePath = hasGlob ? path.slice(0, -1) : path;

    return {
      path: basePath,
      exact: !hasGlob,
      redirect: true,
      component: ({ location: { pathname } }: RouteChildrenProps) => (
        <Redirect to={hasGlob ? pathname.replace(basePath, to) : to} />
      ),
    };
  });
